<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/properties">العقارات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة عقار</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <!--begin::Header-->
              <div class="card-header"><div class="card-title">إضافة إعلان عن طريق رقم الترخيص الإعلاني</div></div>
              <!--end::Header-->
              <!--begin::Form-->
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSucess" :message="message" />

              <form @submit.prevent="checkLicense()">
                <!--begin::Body-->
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label" for="">العميل:</label>
                      <input type="text" class="form-control" placeholder="جوال العميل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label" for="">اسم العميل:</label>
                        <div>{{ userName }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-sm-4 mb-3">
                      <label class="form-label">رقم ترخيص الإعلان:</label>
                      <input type="text" class="form-control" v-model="adLicenseNumber">
                    </div>
                    <div class="col-6 col-sm-4 mb-3">
                      <label class="form-label">نوع هوية المُعلن:</label>
                      <select class="form-control" v-model="idType">
                        <option value="1">رقم الهوية</option>
                        <option value="2">الرقم الموحد للمنشأة</option>
                      </select>
                    </div>
                    <div class="col-6 col-sm-4 mb-3">
                      <label class="form-label">رقم هوية المُعلن:</label>
                      <input type="text" class="form-control" v-model="advertiserId">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">وصف مختصر: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="title">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">الوصف: <span class="req">*</span></label>
                      <textarea class="form-control" cols="5" v-model="description"></textarea>
                    </div>
                  </div>
                </div>
                <!--end::Body-->
                <!--begin::Footer-->
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
                <!--end::Footer-->
              </form>
              <!--end::Form-->
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'PropertiesCreateByLicense',
  data() {
    return {
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      formLoader: false,
      userLoader: false,
      idType: '1',
      adLicenseNumber: null,
      advertiserId: null,
      userMobile: null,
      userName: null,
      // for form owner
      userId: null,
      ownerType: "owner",
      receiptImage: null,
      agencyImage: null,
      receiptNumber: null,
      ownerIdentity: null,
      ownerMobile: null,
      agentIdentity: null,
      agencyNumber: null,
      agentMobile: null,
      adLicenseNumber: null,
      // for property form
      category: 'residential',
      purpose: 'for_sale',
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      street: '',
      buildNumber: '',
      typeId: null,
      price: 0,
      latitude: 24.7136,
      longitude: 46.6753,
      area: 0,
      roomsCount: 0,
      age: null,
      agentId: null,
      status: 'under_review',
      manageProperty: true,
      adDuration: '1',
      isFeatured: false,
      startDate: null,
      rentExpire: null,
      mediaIds: [],
      map: null,
      marker: null,
      frontId: null,
      hasObligations: false,
      saudiBuildingCode: false,
      plotNumber: null,
      meterPrice: null,
      checkerId: null,
      propertyPayments: [],
      title: '',
      description: '',
      falLicense: null,
    };
  },
  methods: {
    subimtData(){
      let owner = {
        userId: this.userId,
        ownerType: this.ownerType,
        receiptNumber: this.receiptNumber,
        ownerIdentity: this.ownerIdentity,
        ownerMobile: this.ownerMobile,
        agentIdentity: this.agentIdentity,
        agencyNumber: this.agencyNumber,
        agentMobile: this.agentMobile,
        adLicenseNumber: this.adLicenseNumber,
        falLicense: this.falLicense,
      };
      let property = {
        category: this.category,
        purpose: this.purpose,
        regionId: this.regionId,
        cityId: this.cityId,
        neighborhoodId: this.neighborhoodId,
        street: this.street,
        buildNumber: this.buildNumber,
        typeId: this.typeId,
        price: this.price,
        latitude: this.latitude,
        longitude: this.longitude,
        propertyType: this.propertyType,
        area: this.area,
        roomsCount: this.roomsCount,
        age: this.age,
        agentId: this.agentId,
        status: this.status,
        manageProperty: this.manageProperty,
        adDuration: this.adDuration,
        isFeatured: this.isFeatured,
        frontId: this.frontId,
        hasObligations: this.hasObligations,
        saudiBuildingCode: this.saudiBuildingCode,
        plotNumber: this.plotNumber,
        meterPrice: this.meterPrice,
        title: this.title,
        description: this.description,
      };
      const formData = new FormData();
      formData.append('property', JSON.stringify(property));
      formData.append('owner', JSON.stringify(owner));
      formData.append('payments', JSON.stringify(this.propertyPayments));
      formData.append('checkerId', this.checkerId);
      
      this.$http.post('/api/admin/properties/create', formData).then(({data}) => {
        toast('تم إضافة الإعلان بنجاح', 'success');
        this.$router.replace(`/properties/update/${data.property.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    checkLicense(){
      this.hasError = false;
      this.formLoader = true;
      if(!this.adLicenseNumber || !this.idType || !this.advertiserId || !this.userId){
        this.message = 'كل البيانات مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        this.formLoader = false;
        window.scroll(0,0);
        return;
      }

      if(!this.title || this.title.trim() == '' || !this.description || this.description.trim() == ''){
        this.message = 'يجب ادخال الوصف والوصف المختصر';
        this.errorNumber = 0;
        this.hasError = true;
        this.formLoader = false;
        window.scroll(0,0);
        return;
      }

      this.$http.post("/api/admin/properties/creatAdByLicense",{
        adLicenseNumber: this.adLicenseNumber.trim(),
        idType: this.idType,
        advertiserId: this.advertiserId.trim(),
      }).then(({data}) => {
        if(!data.result.isValid){
          this.message = data.result.message;
          this.errorNumber = 0;
          this.hasError = true;
          this.formLoader = false;
          window.scroll(0,0);
          return;
        }
        this.ownerType = (this.idType == '1')? 'owner' : 'broker';
        this.checkerId = data.checkerId;
        const regaData = data.result.advertisement;
        if(data.region)
          this.regionId = data.region.id;
        if(data.city)
          this.cityId = data.city.id;
        if(data.neighborhood)
          this.neighborhoodId = data.neighborhood.id;
        this.adLicenseNumber = this.adLicenseNumber;
        if(data.propertyType){
          this.category = data.propertyType.category;
          this.typeId = data.propertyType.id;
        }
        if(data.front){
          this.frontId = data.front.id;
        }
        if(data.age){
          this.age = data.age.id;
        }
        // fill data start 
        this.receiptNumber = regaData.deedNumber;
        this.street = regaData.location.street;
        this.buildNumber = regaData.location.buildingNumber;
        this.latitude = regaData.location.latitude;
        this.longitude = regaData.location.longitude;
        this.price = (regaData.landTotalPrice)? regaData.landTotalPrice : regaData.propertyPrice;
        this.roomsCount = regaData.numberOfRooms ?? 0;
        this.hasObligations = regaData.isConstrained ?? false;
        this.purpose = (regaData.advertisementType == 'بيع')? 'for_sale' : 'for_rent';
        this.saudiBuildingCode = (regaData.complianceWithTheSaudiBuildingCode)? true : false;
        this.plotNumber = regaData.landNumber ?? 0;
        this.area = (regaData.propertyArea)? parseFloat(regaData.propertyArea.toFixed(2)) : 0;
        if(regaData.landTotalPrice){
          this.meterPrice = regaData.propertyPrice;
        }
        this.ownerIdentity = regaData.advertiserId;
        this.agentIdentity = regaData.advertiserId;
        this.ownerMobile = regaData.phoneNumber;
        this.agentMobile = regaData.responsibleEmployeePhoneNumber ?? regaData.phoneNumber;
        this.agencyNumber = regaData.brokerageAndMarketingLicenseNumber;
        this.falLicense = regaData.brokerageAndMarketingLicenseNumber;
        // fill data end 
        this.subimtData();
      }).catch(err => {
        if(err.response && err.response.data && err.response.data.result){
          this.message = err.response.data.result.message;
          this.errorNumber = 0;
        }else{
          [this.message , this.errorNumber] = this.$globalError(err ,true);
        }
        this.hasError = true;
        this.formLoader = false;
        window.scroll(0,0);
      });
    },
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
  },
  created() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
}
</script>
